export default {
  updateFilters: (state, payload) => (state.filters = payload)
}
